import React from 'react';
import {
  BankOutlined,
  FileProtectOutlined,
  LogoutOutlined,
  MobileOutlined,
  SafetyOutlined,
  SettingOutlined,
} from '@ant-design/icons';

import { AdditionalContext } from '@totem/components/ui_components/menus/mainMenu/additionalContext';
import { getSubMenuAdmin } from '@totem/components/ui_components/menus/mainMenu/admin';
import { getSubMenuBilling } from '@totem/components/ui_components/menus/mainMenu/billing';
import { getSubMenuPortfolio } from '@totem/components/ui_components/menus/mainMenu/portfolio';
import { getSubMenuReports } from '@totem/components/ui_components/menus/mainMenu/reports';
import { getSubMenuServices } from '@totem/components/ui_components/menus/mainMenu/services';
import { getSubMenuSurveys } from '@totem/components/ui_components/menus/mainMenu/surveys';
import { getSubMenuTicketing } from '@totem/components/ui_components/menus/mainMenu/ticketing';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import IBDIcon from '@totem/styles/Icon';
import { ContractedServices } from '@totem/types/contractedServices';
import { UserProfile } from '@totem/types/user';

export const getMainMenuItems = (
  userProfile: UserProfile,
  additionalContext: AdditionalContext,
  contractedServices?: ContractedServices,
) => {
  const items: IBMenuItem[] = [
    {
      key: 'yourWork',
      title: 'Your Work',
      label: 'Your Work',
      description: 'Your Work',
      route: '/dashboard/myWork',
      icon: <BankOutlined />,
      hasPermissions: () => {
        return permissions.vendor.hasPermissions(userProfile);
      },
    },
    {
      key: 'sub_portfolio',
      title: 'Portfolio',
      label: 'Portfolio',
      description: 'Portfolio',
      icon: <BankOutlined />,
      hasPermissions: () => {
        const childItems = getSubMenuPortfolio(userProfile);
        return childItems.length > 0;
      },
      children: getSubMenuPortfolio(userProfile),
    },
    {
      key: 'services',
      title: 'Services',
      label: 'Services',
      description: 'Services',
      icon: <SafetyOutlined />,
      hasPermissions: () => {
        const childItems = getSubMenuServices(userProfile);
        return childItems.length > 0;
      },
      children: getSubMenuServices(userProfile, contractedServices),
    },
    {
      key: 'ticketing_main',
      title: 'Ticketing',
      label: 'Ticketing',
      description: 'Ticketing',
      icon: <IBDIcon name="Ticket" />,
      hasPermissions: () => {
        const childItems = getSubMenuTicketing(userProfile);
        return childItems.length > 0;
      },
      children: getSubMenuTicketing(userProfile),
    },
    {
      key: 'surveys',
      title: 'Surveys',
      label: 'Surveys',
      description: 'Surveys & Policy Audits',
      icon: <IBDIcon name="Survey" />,
      hasPermissions: () => {
        const childItems = getSubMenuSurveys(userProfile);
        return childItems.length > 0;
      },
      children: getSubMenuSurveys(userProfile),
    },
    {
      key: 'reports',
      title: 'Reports',
      label: 'Reports',
      description: 'Reports',
      icon: <FileProtectOutlined />,
      hasPermissions: () => {
        const childItems = getSubMenuReports(userProfile, additionalContext);
        return childItems.length > 0;
      },
      children: getSubMenuReports(userProfile, additionalContext),
    },
    {
      key: 'admin',
      title: 'Admin',
      label: 'Admin',
      description: 'Administration',
      icon: <SettingOutlined />,
      hasPermissions: () => {
        const childItems = getSubMenuAdmin(userProfile);
        return childItems.length > 0;
      },
      children: getSubMenuAdmin(userProfile),
    },
    {
      key: 'billingGroup',
      title: 'Billing',
      label: 'Billing',
      description: 'Billing',
      icon: <SettingOutlined />,
      hasPermissions: () => {
        const childItems = getSubMenuBilling(userProfile);
        return childItems.length > 0;
      },
      children: getSubMenuBilling(userProfile),
    },
    {
      key: 'mobile',
      title: 'Mobile',
      label: 'Mobile',
      description: 'Mobile',
      icon: <MobileOutlined />,
      hasPermissions: () => {
        return userProfile.organization.role > 0;
      },
    },
    {
      key: 'logout',
      title: 'Sign Out',
      label: 'Sign Out',
      description: 'Logout',
      route: '/logout',
      icon: <LogoutOutlined />,
      hasPermissions: () => {
        return true;
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
